"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * Represents the KendoReact Error component.
 * Render the error text that will be shown underneath the form editor after a validation.
 */
exports.Error = function (props) {
    var errorClassName = kendo_react_common_1.classNames({
        'k-form-error': true,
        'k-text-start': props.direction === 'start',
        'k-text-end': props.direction === 'end'
    }, props.className);
    return (React.createElement("div", { id: props.id, role: 'alert', style: props.style, className: errorClassName }, props.children));
};
exports.Error.propTypes = {
    id: PropTypes.string,
    direction: PropTypes.oneOf(['start', 'end']),
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node
    ]),
    style: PropTypes.object,
    className: PropTypes.string
};
exports.Error.defaultProps = {
    direction: 'start'
};
exports.Error.displayName = 'KendoReactError';
//# sourceMappingURL=Error.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-labels@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react_nyscn3hbomdbkpk4tysqx62gaa/~/@progress/kendo-react-labels/dist/npm/Error.js
// module id = 6614
// module chunks = 0